<template>
  <div id="page-wrap">
    <headerBox   />
    <router-view/>
    <registerBox v-if="!$store.state.isLogin&&registerShow"/>
    <footerBox  />
  </div>
</template>

<script>
import headerBox from './template/header'
import footerBox from './template/footer'
import registerBox from './template/register'
export default {
  name: 'App',
  data() {
    return {
      registerShow:false
    }
  },
  components:{
    headerBox,
    footerBox,
    registerBox
  },
  created() {
    this.showregister(this.$route)
    if(!this.$store.state.isLogin)localStorage.removeItem('userdata')
  },
  methods: {
    showregister(newValue){
      if(newValue.meta == 'register'){
        this.registerShow = true
      }else{
        this.registerShow = false
      }
    }
  },
  watch: {
    $route(newValue){
      this.showregister(newValue)
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue